import {
    InsuranceBuildingResp,
    InsuranceDoors,
    Group,
    InsurancePersonal,
    StepsIconHouse,
    Basic,
    Extras,
    Buildings,
    Interruptions,
    Responsibility,
    Stock,
    Vehicle
} from '../../../icons'

export const icons = {
    household: <InsuranceDoors color="secondary.500" />,
    property: <StepsIconHouse color="secondary.500" />,
    common: <Group color="secondary.500" />,
    lifeLiability: <InsurancePersonal color="secondary.500" />,
    propertyLiability: <InsuranceBuildingResp color="secondary.500" />,
    basic: <Basic color="secondary.500" />,
    extras: <Extras color="secondary.500" />,
    buildings: <Buildings color="secondary.500" />,
    stock: <Stock color="secondary.500" />,
    vehicle: <Vehicle color="secondary.500" />,
    responsibility: <Responsibility color="secondary.500" />,
    interruptions: <Interruptions color="secondary.500" />,
}